export const caseStudies = [
  {
    slug: 'assad-j-legal-services',
    name: 'Assad J Legal Services',
    url: 'https://assadjlegalservices.com/',
    image: '/projects/assad-legal-hero.png',
    category: 'Legal-services website',
    year: '2026',
    featured: true,
    accent: '#183A52',
    headline: 'A clear, credible path from legal question to consultation.',
    summary: 'A service-led website for an Ontario paralegal practice, organized around plain-language legal support, trust, and a direct consultation journey.',
    services: ['Website strategy', 'Responsive design', 'Lead capture', 'Local SEO foundation'],
    problem: 'People looking for legal help need to understand whether a provider handles their issue, trust the person behind the practice, and know what to do next. The website needed to communicate all three without making visitors work for the answer.',
    approach: 'The experience leads with the practice areas, brings the licensed paralegal and multilingual support into the trust story, and repeats one clear consultation path across the site. Location and contact details remain easy to find for local-intent visitors.',
    delivered: [
      'Service architecture for the practice areas',
      'Responsive, accessibility-conscious interface',
      'Consultation and contact journey',
      'Metadata and local search foundation',
    ],
    outcome: 'The finished site gives the practice a professional home that can explain its services, support local discovery, and turn a high-intent visit into a concrete enquiry.',
  },
  {
    slug: 'fieldstack',
    name: 'Fieldstack',
    url: 'https://fieldwork-swart-rho.vercel.app/',
    image: '/projects/fieldstack.jpg',
    category: 'Field operations platform',
    year: '2026',
    featured: true,
    accent: '#22563D',
    headline: 'A product story that connects the first call to the final payment.',
    summary: 'A focused launch experience for a field-operations platform, showing how leads, schedules, jobs, crews, quotes, invoices, and payments fit into one workflow.',
    services: ['Product positioning', 'Interface design', 'Responsive development', 'Launch funnel'],
    problem: 'Field-service software can become a wall of features. The challenge was to make a broad operations platform understandable quickly while giving early customers a reason to take the next step.',
    approach: 'The page frames the product as one connected business flow, then uses a product workspace, concrete modules, and a founding-customer offer to move from promise to proof. The visual system stays grounded in the day-to-day work of operators.',
    delivered: [
      'Product narrative and page hierarchy',
      'Interactive software visualization',
      'Feature and workflow communication',
      'Early-access conversion journey',
    ],
    outcome: 'The resulting launch page makes a complex product easier to understand and gives interested field-service operators a clear route into the founding-customer program.',
  },
  {
    slug: 'tracklytics',
    name: 'Tracklytics',
    url: 'https://tracklytics.ca/',
    image: '/projects/tracklytics-hero.png',
    category: 'SaaS product launch',
    year: '2026',
    featured: true,
    accent: '#3663D8',
    headline: 'Document analytics presented as a useful sales workflow, not a feature list.',
    summary: 'A SaaS experience for sending trackable documents, understanding page-level engagement, collecting signatures, and acting on buyer interest.',
    services: ['SaaS website', 'Product UX', 'Responsive development', 'Conversion structure'],
    problem: 'Document tracking spans several jobs - sharing, analytics, signatures, follow-up, and integrations. The product needed a clear story that connected those capabilities to better timing and better sales conversations.',
    approach: 'The experience starts with the outcome, then demonstrates how engagement data becomes useful context. Features, integrations, pricing, and common questions are organized to support both quick evaluation and deeper product research.',
    delivered: [
      'Product-led landing experience',
      'Document analytics interface patterns',
      'Pricing and feature architecture',
      'Responsive product communication',
    ],
    outcome: 'Tracklytics now has a coherent public product story: what it does, who it helps, and how a team can start using it are all visible from one connected experience.',
  },
  {
    slug: 'nba-cap-tracker',
    name: 'NBA Cap Tracker',
    url: 'https://www.nbacaptracker.com/',
    image: '/projects/nba-cap-tracker.jpg',
    category: 'Live sports data product',
    year: '2025',
    featured: false,
    accent: '#C44A35',
    headline: 'Dense salary-cap data made easier to explore.',
    summary: 'A basketball data product with team and player salary views, cap tables, a trade machine, and supporting news and community features.',
    services: ['Custom software', 'Data interface', 'Responsive development', 'Information architecture'],
    problem: 'Salary-cap research involves a large amount of connected data. Fans and analysts need to move between teams, players, seasons, and transactions without losing context.',
    approach: 'The interface treats tables and filters as the main product, using strong hierarchy and clear navigation to keep dense information usable. Supporting tools extend the experience from research into trade exploration and discussion.',
    delivered: [
      'Team and player data views',
      'Salary and cap table interface',
      'Trade exploration workflow',
      'Responsive navigation and filtering',
    ],
    outcome: 'The platform brings several cap-research tasks into one browsable destination, with the data itself kept central to the experience.',
  },
  {
    slug: 'neuma',
    name: 'Neuma',
    url: 'https://neumatech.co/',
    image: '/projects/neuma-clean.jpg',
    category: 'Wellness commerce website',
    year: '2025',
    featured: false,
    accent: '#406565',
    headline: 'A calm storefront for a breath-focused wearable.',
    summary: 'A commerce experience that introduces Neuma, explains a novel wellness product, and supports the path from education to purchase.',
    services: ['E-commerce website', 'Visual design', 'Responsive development', 'Product storytelling'],
    problem: 'A new physical product has to establish its purpose before asking for a purchase. The site needed to explain the role of breath and biofeedback while keeping the product tangible and the shopping journey clear.',
    approach: 'The design uses calm visual pacing, product-focused imagery, and educational sections to introduce the idea before surfacing the commercial details. The storefront retains familiar purchase patterns around a distinct brand story.',
    delivered: [
      'Product storytelling and hierarchy',
      'Responsive Shopify experience',
      'Education-to-purchase journey',
      'Brand-aligned interaction design',
    ],
    outcome: 'Neuma has a focused digital storefront that can educate visitors about an unfamiliar product and carry that interest into a familiar purchase experience.',
  },
];

export const getCaseStudyBySlug = (slug) => caseStudies.find((study) => study.slug === slug);

export default caseStudies;
